<nav class="bottom-nav" role="navigation" aria-label="Main">
  @for (tab of visibleTabs(); track tab.route) {
    <a class="tab"
       [routerLink]="tab.route"
       [class.active]="activeSection() === tab.section"
       [attr.aria-current]="activeSection() === tab.section ? 'page' : null">
      <mat-icon class="tab-icon">{{ tab.icon }}</mat-icon>
      <span class="tab-label">{{ tab.label }}</span>
    </a>
  }

  <!-- Compliance, Settings and help live in the drawer rather than as their own tabs. -->
  <button type="button" class="tab" [class.active]="inMoreSection()" (click)="openMenu()">
    <mat-icon class="tab-icon">menu</mat-icon>
    <span class="tab-label">More</span>
  </button>
</nav>
